import executeDownload from "lib/api/download";

export default class Downloader {
  constructor() {
    this.cancelled = false;
  }

  async download({
    level,
    country,
    state,
    county,
    start,
    end,
    hexagons,
    baseline,
    onCompleted,
    onError,
  }) {

    try {
      const { data, filename } = await executeDownload({
        level,
        country: level >= 1 ? country : undefined,
        state: level >= 2 ? state : undefined,
        county: level >= 3 ? county : undefined,
        start,
        end,
        baseline,
        hexagons
      });

      if (!this.cancelled) {
        this.browserDownload(filename, data);
        onCompleted();
      }
    } catch (err) {
      onError(err);
    }
  }

  browserDownload(filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);


    element.click();

    document.body.removeChild(element);
  }
}
